import { Box } from '@material-ui/core'
import React, { useEffect } from 'react'
import { useState } from 'react'
import ManaWorld from '../../logic/loop/ManaWorld'
import ManaNode from '../../logic/mana/nodes/ManaNode'
import { shape } from '../../theme'

import styled from 'styled-components'

import SparklesIcon from 'mdi-material-ui/Sparkles'
import SourceMergeIcon from 'mdi-material-ui/SourceMerge'
import { Tooltip } from '@material-ui/core'

const ParticleCountRoot = styled.div`
	display: flex;
	align-items: center;
	
	color: white;

	white-space: nowrap;
`

export default function ParticleCount({ manaWorld = undefined as (undefined | ManaWorld) }) {

	const [particleCount, setParticleCount] = useState(0)
	const [nodeCount, setNodeCount] = useState(0)

	useEffect(() => {
		if (manaWorld) {
			const trackingInterval = setInterval(() => {

				setParticleCount(
					manaWorld.getItems().reduce((acc, item) => {
						if (item instanceof ManaNode) {
							return acc + item.particles.length
						}
						return acc
					}, 0)
				)

				setNodeCount(
					manaWorld.getItems().reduce((acc, item) => {
						if (item instanceof ManaNode) {
							return acc + 1
						}
						return acc
					}, 0)
				)
			}, 1000)

			return () => {
				clearInterval(trackingInterval)
			}
		}
	}, [manaWorld])

	return (
		<ParticleCountRoot>
			<Box p="6px 12px">
				<Tooltip title="Particle count">
					<SparklesIcon fontSize="small" />
				</Tooltip>
			</Box>
			<Box borderRadius={shape.borderRadius} p="4px 12px" bgcolor="rgba(255, 255, 255, 0.12)">
				{particleCount}
			</Box>
			<Box p="6px 12px">
				<Tooltip title="Node count">
					<SourceMergeIcon fontSize="small" />
				</Tooltip>
			</Box>
			<Box borderRadius={shape.borderRadius} p="4px 12px" bgcolor="rgba(255, 255, 255, 0.12)">
				{nodeCount}
			</Box>
		</ParticleCountRoot>
	)
}
